import inherits from 'inherits'
import PropertiesActivator from 'bpmn-js-properties-panel/lib/PropertiesActivator'
import CamundaPropertiesProvider from 'bpmn-js-properties-panel/lib/provider/camunda/CamundaPropertiesProvider'

import beeProps from './parts/BotProps'
import iteratorProps from './parts/IteratorProps'
import refactorProps from './parts/RefactorProps'
import unMapProps from './parts/UnMapProps'
import jsonPathProps from './parts/JsonPathProps'
import appenderProps from './parts/AppenderProps'
import formProps from './parts/UserTaskProps'

// The general tab contains all bpmn relevant properties.
// The properties are organized in groups.
// function createGeneralTabGroups (element, bpmnFactory, elementRegistry, translate) {
//   let generalGroup = {
//     id: 'general',
//     label: 'General',
//     entries: []
//   }
//   idProps(generalGroup, element, translate)
//   nameProps(generalGroup, element, translate)
//   processProps(generalGroup, element, translate)
//
//   let detailsGroup = {
//     id: 'details',
//     label: 'Details',
//     entries: []
//   }
//   linkProps(detailsGroup, element, translate)
//   eventProps(detailsGroup, element, bpmnFactory, elementRegistry, translate)
//
//   let documentationGroup = {
//     id: 'documentation',
//     label: 'Documentation',
//     entries: []
//   }
//
//   documentationProps(documentationGroup, element, bpmnFactory, translate)
//
//   return [
//     generalGroup,
//     detailsGroup,
//     documentationGroup
//   ]
// }

// let getInputOutputParameterLabel = function (param, translate) {
//   if (is(param, 'camunda:InputParameter')) {
//     return translate('Input Parameter')
//   }
//
//   if (is(param, 'camunda:OutputParameter')) {
//     return translate('Output Parameter')
//   }
//
//   return ''
// }

// function createInputOutputTabGroups (element, bpmnFactory, elementRegistry, translate) {
//   let inputOutputGroup = {
//     id: 'input-output',
//     label: translate('Parameters'),
//     entries: []
//   }
//
//   let options = inputOutput(inputOutputGroup, element, bpmnFactory, translate)
//
//   let inputOutputParameterGroup = {
//     id: 'input-output-parameter',
//     entries: [],
//     enabled: function (element, node) {
//       return options.getSelectedParameter(element, node)
//     },
//     label: function (element, node) {
//       let param = options.getSelectedParameter(element, node)
//       return getInputOutputParameterLabel(param, translate)
//     }
//   }
//
//   inputOutputParameter(inputOutputParameterGroup, element, bpmnFactory, options, translate)
//
//   return [
//     inputOutputGroup,
//     inputOutputParameterGroup
//   ]
// }

// Create the Bot Tab
function createBotTabGroups(element, bpmnFactory, elementRegistry, translate) {
  let botGroup = {
    id: 'bot-group',
    label: 'Bot selection',
    entries: []
  }

  // Add the bot props to the bot group.
  beeProps(botGroup, element)

  let iteratorGroup = {
    id: 'Iterator-group',
    label: 'Iterator options',
    entries: []
  }
  // Add the Iterator props to the iterator group.
  iteratorProps(iteratorGroup, element)

  let refactorGroup = {
    id: 'Refactor-group',
    label: 'Refactor options',
    entries: []
  }

  // Add the Refactor props to the iterator group.
  refactorProps(refactorGroup, element, bpmnFactory, translate)

  let unMapGroup = {
    id: 'De-Structure-group',
    label: 'De-Structure options',
    entries: []
  }

  // Add the UnMap props to the destructure group.
  unMapProps(unMapGroup, element, bpmnFactory, translate)

  let jsonPathGroup = {
    id: 'JsonPath-group',
    label: 'JsonPath Expression',
    entries: []
  }

  // Add the UnMap props to the JsonPath group.
  jsonPathProps(jsonPathGroup, element, bpmnFactory, translate)

  let appenderGroup = {
    id: 'Appender-group',
    label: 'Appender options',
    entries: []
  }

  // Add the UnMap props to the iterator group.
  appenderProps(appenderGroup, element, bpmnFactory, translate)

  let formGroup = {
    id: 'form-group',
    label: 'User Form options',
    entries: []
  }

  // Add the UnMap props to the iterator group.
  formProps(formGroup, element, bpmnFactory, translate)

  return [
    botGroup,
    iteratorGroup,
    refactorGroup,
    unMapGroup,
    jsonPathGroup,
    appenderGroup,
    formGroup
  ]
}

// // Create the iterate Tab
// function createIterateTabGroups (element, elementRegistry) {
//
//
// return [
//   IteratorGroup
// ]
// }

function BotPropertiesProvider(
  eventBus,
  bpmnFactory,
  elementRegistry,
  elementTemplates,
  translate
) {
  PropertiesActivator.call(this, eventBus)

  let camunda = new CamundaPropertiesProvider(
    eventBus,
    undefined,
    bpmnFactory,
    elementRegistry,
    elementTemplates,
    translate
  )

  this.getTabs = function(element) {
    // The "Bot" tab
    let botTab = {
      id: 'bot',
      label: 'Tulip Panel',
      groups: createBotTabGroups(
        element,
        bpmnFactory,
        elementRegistry,
        translate
      )
    }
    let tabs = camunda.getTabs(element)

    let allowedTabs = ['general', 'input-output']

    tabs = tabs.filter(item => allowedTabs.includes(item.id))

    tabs.splice(1, 0, botTab)
    return tabs
  }
}

BotPropertiesProvider.$inject = [
  'eventBus',
  'bpmnFactory',
  'elementRegistry',
  'elementTemplates',
  'translate'
]

inherits(BotPropertiesProvider, PropertiesActivator)

export default BotPropertiesProvider
